import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const ControlPutAway = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M5.546 2.946a.5.5 0 0 1 .638-.057l.07.057 4.2 4.2a.5.5 0 0 1 .057.638l-.057.07-4.2 4.2a.5.5 0 0 1-.765-.638l.057-.07L9.393 7.5 5.546 3.654a.5.5 0 0 1-.057-.638l.057-.07z" transform="matrix(0 -1 -1 0 15.5 15.5)"/>
      </svg>)} {...props}/>));
export default ControlPutAway;
